var exports = {
  "pq": "xdbfd91f1--cfd21d--info",
  "ki": "xdbfd91f1--cfd21d--info--without_summary",
  "qx": "xdbfd91f1--cfd21d--info--fat",
  "DD": "xdbfd91f1--cfd21d--title",
  "x4": "xdbfd91f1--cfd21d--title--with-disclaimer",
  "hl": "xdbfd91f1--cfd21d--address",
  "Cp": "xdbfd91f1--cfd21d--address-link",
  "Aj": "xdbfd91f1--cfd21d--commute_set",
  "Io": "xdbfd91f1--cfd21d--distance",
  "Q3": "xdbfd91f1--cfd21d--highway",
  "kv": "xdbfd91f1--cfd21d--railway",
  "hr": "xdbfd91f1--cfd21d--hr",
  "E9": "xdbfd91f1--cfd21d--counter_set-item",
  "k3": "xdbfd91f1--cfd21d--counter_set",
  "nv": "xdbfd91f1--cfd21d--counter_set-item--tooltip",
  "Pf": "xdbfd91f1--cfd21d--label",
  "Uq": "xdbfd91f1--cfd21d--value",
  "dw": "xdbfd91f1--cfd21d--helper",
};

module.exports = exports;
